import { Box, Button, Fade, Grid, Slide, Typography, useTheme } from "@material-ui/core";
import { EnumFasesSacola } from "../../../cardapio-sacola";
import { useStyles } from "./fazendo-pedido-styles";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Carregando, useNotificacoes } from "components";
import { AvisoIcon } from "components/icons/aviso-icon";
import { CancelarIcon } from "components/icons/cancelar-icon";
import { TentarNovamenteIcon } from "components/icons/tentar-novamente-icon";
import { usePedidos } from "services/providers/pedidos-provider";
import { useHistory, useParams } from "react-router-dom";
import { EnumTipoPedido } from "api/cardapio/models/pedido/efetuar-pedido";

export interface FazendoPedidoProps {
    faseSacola: EnumFasesSacola;
    fecharSacola: () => void;
    setScannerComanda: (open: boolean) => void;
    handlePedidoFluxo: (nextOrBack: React.MutableRefObject<0 | 1>) => void
    onClickProximaFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
    onClickVoltarFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
}

export const FazendoPedido = ({
    faseSacola,
    fecharSacola,
    setScannerComanda,
    handlePedidoFluxo,
    onClickProximaFase,
    onClickVoltarFase
}: FazendoPedidoProps) => {
    const classes = useStyles()
    const theme = useTheme()
    const { handlePedido, cancelarPedido, setCodComanda } = usePedidos()
    const { showSuccessMessage } = useNotificacoes()
    const [erro, setErro] = useState<string>('')
    const nextOrBack = useRef<0 | 1>(1)
    const history = useHistory()
    const { empresaId } = useParams<{ empresaId: string }>()

    const faseFazendoPedido = faseSacola === EnumFasesSacola.FazendoPedido

    const fazerPedido = useCallback(async () => {
        try {
            setErro('')
            const pedido = await handlePedido()
            showSuccessMessage('Pedido realizado com sucesso!')
            onClickVoltarFase(nextOrBack, EnumFasesSacola.Sacola)
            fecharSacola()
            if (pedido && pedido.tipoPedido.codigo !== EnumTipoPedido.LOCAL) {
                history.push(`${empresaId}/pedido/${pedido.id}`)
            }
        }
        catch (err: any) {
            if (err.message.includes('comanda não foi localizada')) {
                setCodComanda(null)
            }
            setErro(err.message)
        }
    }, [empresaId, fecharSacola, handlePedido, history, onClickVoltarFase, setCodComanda, showSuccessMessage])

    const handleCancelarPedido = useCallback(() => {
        cancelarPedido()
        showSuccessMessage('Pedido cancelado!')
        onClickVoltarFase(nextOrBack, EnumFasesSacola.Sacola)
        fecharSacola()
    }, [cancelarPedido, onClickVoltarFase, fecharSacola, showSuccessMessage])

    useEffect(() => {
        if (faseFazendoPedido) fazerPedido()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [faseFazendoPedido])

    return (
        <Slide direction={nextOrBack.current === 1 ? 'left' : "right"} mountOnEnter unmountOnExit in={faseFazendoPedido}>
            <Box height={"100%"} width={"100%"} className={classes.boxContainer}>
                <Box className={classes.content}>
                    <div className={classes.scrollable} style={{
                        height: '100%',
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        {!erro ? (
                            <Fade in>
                                <div>
                                    <Carregando
                                        carregando
                                        titulo='Preparando pedido...'
                                        mensagem={'Aguarde enquanto tentamos finalizar o seu pedido'}
                                    />
                                </div>
                            </Fade>
                        ) : (
                            <Fade in>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Box width="100%" display="flex" justifyContent="center">
                                            <AvisoIcon tipo="GERAL" class={classes.avisoIcon} />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h4">
                                            <Box textAlign={"center"} fontWeight={700}>
                                                Ocorreu um erro
                                            </Box>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box textAlign={"center"} my={2}>
                                            <Typography>
                                                Detalhe: {erro}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            color="primary"
                                            size="large"
                                            onClick={() => {
                                                handlePedidoFluxo(nextOrBack)
                                            }}
                                        >
                                            <TentarNovamenteIcon tipo="BUTTON_PRIMARY" />
                                            {erro.includes('comanda não foi localizada') ? 'Ler a comanda novamente' : 'Tentar novamente'}
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button size="large" variant="outlined" color={theme.palette.type === 'dark' ? "inherit" : "primary"} fullWidth onClick={handleCancelarPedido}>
                                            <CancelarIcon tipo="BUTTON" />
                                            Cancelar pedido
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Fade>
                        )}
                    </div>
                </Box>
            </Box>
        </Slide>

    )
}